import { render } from "./DayViewer.vue?vue&type=template&id=6f68aff0"
import script from "./DayViewer.vue?vue&type=script&lang=js"
export * from "./DayViewer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__